import './../toolbar/index';
import AppContentController from './content.controller';

const appContentComponent = {
	templateUrl: 'layout/content/content.html',
	controller: AppContentController,
	bindings: {
		$router: '<'
	}
};

angular
	.module('app.content', [
		'app.toolbar'
	])
	.component('appContent', appContentComponent);
	
